var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-block",on:{"click":_vm.edit}},[_c('span',{style:({ marginLeft: '1em'})},[_vm._v(" "+_vm._s(_vm.depot.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }